import { render, staticRenderFns } from "./ProductDirectory.vue?vue&type=template&id=c8b57b1e&scoped=true&"
import script from "./ProductDirectory.vue?vue&type=script&lang=ts&"
export * from "./ProductDirectory.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDirectory.vue?vue&type=style&index=0&id=c8b57b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b57b1e",
  null
  
)

export default component.exports